import React, { useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const ErrorScreen = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { sendEvent } = useContext(DataLayerEventContext);

  // useEffect(() => {
  //   sendEvent('age_verification_fail');
  // }, []);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (isOpenModal) {
        const isClickOnImage =
          event.target.tagName === 'IMG' &&
          event.target.src.includes('age-modal.png');

        if (!isClickOnImage) {
          setIsOpenModal(false);
        }
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [isOpenModal]);

  const handleButtonClick = (event) => {
    event.stopPropagation();
    setIsOpenModal(!isOpenModal);
  };

  return (
    <div className={`${styles.statusScreen} ${styles.error}`}>
      <div className={styles.content}>
        <div className={styles.message}>Упс, не вийшло</div>
      </div>
      <div
        className={classNames(
          styles.modalContainer,
          isOpenModal && styles.backgroundModalContainer
        )}
      >
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={handleButtonClick}
        >
          <circle cx="17" cy="17" r="16" stroke="white" strokeWidth="2" />
          <path
            d="M17.543 20.3916H15.1475C15.1546 19.7256 15.2119 19.167 15.3193 18.7158C15.4268 18.2575 15.6058 17.8421 15.8564 17.4697C16.1143 17.0973 16.4544 16.7035 16.877 16.2881C17.2064 15.973 17.5036 15.6758 17.7686 15.3965C18.0335 15.11 18.2448 14.8092 18.4023 14.4941C18.5599 14.1719 18.6387 13.8031 18.6387 13.3877C18.6387 12.9365 18.5635 12.5534 18.4131 12.2383C18.2627 11.9232 18.0407 11.6833 17.7471 11.5186C17.4606 11.3538 17.1025 11.2715 16.6729 11.2715C16.3148 11.2715 15.9782 11.3431 15.6631 11.4863C15.348 11.6224 15.0938 11.8372 14.9004 12.1309C14.707 12.4173 14.6032 12.7969 14.5889 13.2695H12C12.0143 12.3672 12.2292 11.6081 12.6445 10.9922C13.0599 10.3763 13.6185 9.91439 14.3203 9.60645C15.0221 9.2985 15.8063 9.14453 16.6729 9.14453C17.6325 9.14453 18.4525 9.30924 19.1328 9.63867C19.8132 9.96094 20.3324 10.4336 20.6904 11.0566C21.0557 11.6725 21.2383 12.4173 21.2383 13.291C21.2383 13.9212 21.113 14.4941 20.8623 15.0098C20.6117 15.5182 20.2858 15.9945 19.8848 16.4385C19.4837 16.8753 19.0505 17.3122 18.585 17.749C18.1839 18.1143 17.9118 18.5117 17.7686 18.9414C17.6253 19.3639 17.5501 19.8473 17.543 20.3916ZM14.9326 23.7432C14.9326 23.3564 15.0651 23.0306 15.3301 22.7656C15.5951 22.4935 15.9567 22.3574 16.415 22.3574C16.8734 22.3574 17.235 22.4935 17.5 22.7656C17.765 23.0306 17.8975 23.3564 17.8975 23.7432C17.8975 24.1299 17.765 24.4593 17.5 24.7314C17.235 24.9964 16.8734 25.1289 16.415 25.1289C15.9567 25.1289 15.5951 24.9964 15.3301 24.7314C15.0651 24.4593 14.9326 24.1299 14.9326 23.7432Z"
            fill="white"
          />
        </svg>
        {isOpenModal && (
          <div className={styles.modal}>
            <img src="/images/age-modal.png" alt="age-modal" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorScreen;
